// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortControlStyles } from "@pace/Overrides/Widgets/MyLists/MyListsSortControl";
import defaultPaginationStyle from "@pace/XDL/PreStyle/pagination";
import { getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

sortControlStyles.toggleFilterButton = {
    color: "common.background",
    css: css`
        padding: 0;
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: transparent;
            border-color: transparent;
        }
        ${({ filtersOpen }: any) =>
            filtersOpen &&
            `
            svg{
                color: ${getSystemColor("secondary")};
            }
        `}
    `,
};
sortControlStyles.sortByWrapper = {
    css: css`
        display: inline-block;
    `,
};
sortControlStyles.sortBySelect = {
    ...defaultPaginationStyle.defaultProps?.selectProps,
    cssOverrides: {
        formField: css`
            display: flex;
            align-items: center;
        `,
        formInputWrapper: css`
            width: auto;
            max-width: 140px;
            min-width: 51px;
            &&&& {
                
                &&&& > span {
                    padding: 5px;
                }
            }
            ${xScreen("lte", "md")} {
                width: inherit;
            }
        `,
    },
};
